import React, { useEffect, useState } from "react";
import STLViewer from "../Canvas/STLViewer";
import axios from "axios";
import config from '../../config';
import { headers } from '../../token';
import ColorBox from '../ColorBox';
import STLViewerQuot from "../Canvas/STLViewerQuot";
import vAdminformat from "../../adminFormat";

const ViewsMouldFile = ({ CloseViewFiles, urlFile, Object }) => {

    const getFileExtension = (url) => {
        const parts = url.split('.');
        return parts.length > 1 ? parts.pop().toLowerCase() : '';
    };

    const fileExtension = getFileExtension(urlFile);
    const isSTL = fileExtension === 'stl' || fileExtension === 'obj';

    return (
        <div>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        {Object.name 
                        }
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><a href="javascript: void(0);">Files</a></li>
                                <li className="breadcrumb-item active">Mould</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="card p-5">

                    <div className="col-12">
                        <div className=" d-sm-flex align-items-center justify-content-between" style={{ marginTop: "-1px" }}>
                            <button className='btn btn-warning' onClick={CloseViewFiles}>Go Back</button>

                        </div>
                    </div>
                    <div>
                        <div className="row">
                            <div className="col-6">
                                <center> <h6>{Object.name}</h6></center>
                                <div>
                                    {isSTL ? <STLViewerQuot url={urlFile}  mystl={true} /> : (
                                        <div style={{ width: "100%", height: "100%", position: "relative" }}>
                                            <img src={urlFile} alt="STL" style={{ width: "100%", height: "100%" }} />
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6">
                            <center> <h4 className="mb-3 text-primary">Mould Information</h4></center>
    <div className="shadow-sm border-0" >
      <div className="card-body" style={{height: "50.5vh"}}>
        <div className="mb-2"><strong>Internal Name:</strong> {Object.mould_name}</div>
        <div className="mb-2"><strong>Client Reference:</strong> {Object.mould_reference}</div>
        <div className="mb-2"><strong>Description:</strong> {Object.comment}</div>

        <hr />

        <div className="mb-2"><strong>Type of Mould:</strong> {Object.mould_type}</div>
        <div className="mb-2"><strong>Condition:</strong> {Object.mould_condition}</div>
        <div className="mb-2"><strong>Origin:</strong> New mould (created: {vAdminformat.FormatDateTime(Object.date_created)})</div>

        <hr />

     {/*    <div className="mb-2"><strong>Pattern Material:</strong> {Object.mould_material}</div> */}
        <div className="mb-2"><strong>Ring Size:</strong> {Object.mould_size}</div>

      </div>
    </div>
  </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewsMouldFile;
